/* Guru Krupa Fashion — show metres in the sticky add-to-cart bar for half-metre fabrics. */
(() => {
  const isMetrePage = () => !!document.querySelector('quantity-selector-component[data-unit="half-metre"]');

  const toMetres = (el) => {
    if (!isMetrePage()) return;
    const text = el.textContent.trim();
    if (/^\d+$/.test(text)) {
      el.textContent = `${parseInt(text, 10) / 2} m`;
    }
  };

  const init = () => {
    document.querySelectorAll('sticky-add-to-cart [ref="quantityNumber"]').forEach((el) => {
      toMetres(el);
      new MutationObserver(() => toMetres(el)).observe(el, { childList: true, characterData: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
